module.exports = __webpack_public_path__ + "img/gsb4.52efc0cb.png";